module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-address-form__form-group-item"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.$parent.form[_vm.$parent.address].mobile),
      expression: "$parent.form[$parent.address].mobile",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "name": "mobile-phone"
    },
    domProps: {
      "value": (_vm.$parent.form[_vm.$parent.address].mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$parent.form[_vm.$parent.address], "mobile", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "mobile-phone"
    }
  }, [_c('span', {
    staticClass: "label-text"
  }, [_vm._v("\n            Mobiltelefon\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e59673d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./static/js/Order/components/Forms/Fields/MobilePhone.vue
// module id = 832
// module chunks = 0